<template>
  <div class="sidebar-container" :class="{ 'dark-mode': isDarkMode }">
    <!-- Compact sidebar (always visible) -->
    <aside class="sidebar" :class="{ 'dark-mode': isDarkMode, 'mobile-open': isMobile && mobileIsOpen }">
      <!-- Logo <div class="logo-icon" @click="toggleSidebar"> -->
      <div class="logo-icon" @click="toggleUserMenu" style="cursor: pointer;">
        <img :src="logoSrc" alt="Logo" style="object-fit: contain;" referrerpolicy="no-referrer">
      </div>

      <!-- Navigation links (icon only) -->
      <nav class="nav-menu">
        <router-link v-if="!scopedSession" to="/dashboard" class="nav-item" :class="{ 'active': $route.path === '/dashboard' }" title="Dashboard" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="3" width="7" height="7" rx="1" />
            <rect x="14" y="14" width="7" height="7" rx="1" />
            <rect x="3" y="14" width="7" height="7" rx="1" />
          </svg>
          <span class="tooltip-text">Dashboard</span>
        </router-link>



        <router-link to="/dashboard/chatbots" class="nav-item" :class="{ 'active': $route.path === '/dashboard/chatbots' || isChatbotPage }" title="Agents" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="3" y="11" width="18" height="10" rx="2"/>
            <circle cx="12" cy="5" r="2"/>
            <path d="M12 7v4"/>
            <line x1="8" y1="16" x2="8.01" y2="16"/>
            <line x1="16" y1="16" x2="16.01" y2="16"/>
          </svg>
          <span class="tooltip-text">Agents</span>
        </router-link>

        <div class="nav-item" :class="{ 'active': $route.path.includes('/playground') }" title="Programme mon agent IA" @click="handlePlaygroundClick" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
             <polyline points="16 18 22 12 16 6"></polyline>
             <polyline points="8 6 2 12 8 18"></polyline>
          </svg>
          <span class="tooltip-text">Programme mon agent IA</span>
        </div>

        <!-- Appels vocaux : la page d'appel de test (même origine, donc même session) -->
        <div class="nav-item" title="Appel vocal" @click="handleAppelClick" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72c.13.96.37 1.9.72 2.81a2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45c.91.35 1.85.59 2.81.72A2 2 0 0 1 22 16.92z"></path>
          </svg>
          <span class="tooltip-text">Appel vocal</span>
        </div>
        
        <div v-if="!scopedSession" class="nav-item" style="cursor: pointer;" :class="{ 'active': $route.path.startsWith('/dashboard/whatsapp-signup') }" title="Comptes WhatsApp" @click="proGuard(goWhatsApp)" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 32 32" fill="currentColor">
            <path d="M26.576 5.363c-2.69-2.69-6.406-4.354-10.511-4.354-8.209 0-14.865 6.655-14.865 14.865 0 2.732 0.737 5.291 2.022 7.491l-0.038-0.070-2.109 7.702 7.879-2.067c2.051 1.139 4.498 1.809 7.102 1.809h0.006c8.209-0.003 14.862-6.659 14.862-14.868 0-4.103-1.662-7.817-4.349-10.507l0 0zM16.062 28.228h-0.005c-0 0-0.001 0-0.001 0-2.319 0-4.489-0.64-6.342-1.753l0.056 0.031-0.451-0.267-4.675 1.227 1.247-4.559-0.294-0.467c-1.185-1.862-1.889-4.131-1.889-6.565 0-6.822 5.531-12.353 12.353-12.353s12.353 5.531 12.353 12.353c0 6.822-5.53 12.353-12.353 12.353h-0zM22.838 18.977c-0.371-0.186-2.197-1.083-2.537-1.208-0.341-0.124-0.589-0.185-0.837 0.187-0.246 0.371-0.958 1.207-1.175 1.455-0.216 0.249-0.434 0.279-0.805 0.094-1.15-0.466-2.138-1.087-2.997-1.852l0.010 0.009c-0.799-0.74-1.484-1.587-2.037-2.521l-0.028-0.052c-0.216-0.371-0.023-0.572 0.162-0.757 0.167-0.166 0.372-0.434 0.557-0.65 0.146-0.179 0.271-0.384 0.366-0.604l0.006-0.017c0.043-0.087 0.068-0.188 0.068-0.296 0-0.131-0.037-0.253-0.101-0.357l0.002 0.003c-0.094-0.186-0.836-2.014-1.145-2.758-0.302-0.724-0.609-0.625-0.836-0.637-0.216-0.010-0.464-0.012-0.712-0.012-0.395 0.010-0.746 0.188-0.988 0.463l-0.001 0.002c-0.802 0.761-1.3 1.834-1.3 3.023 0 0.026 0 0.053 0.001 0.079l-0-0.004c0.131 1.467 0.681 2.784 1.527 3.857l-0.012-0.015c1.604 2.379 3.742 4.282 6.251 5.564l0.094 0.043c0.548 0.248 1.25 0.513 1.968 0.74l0.149 0.041c0.442 0.14 0.951 0.221 1.479 0.221 0.303 0 0.601-0.027 0.889-0.078l-0.031 0.004c1.069-0.223 1.956-0.868 2.497-1.749l0.009-0.017c0.165-0.366 0.261-0.793 0.261-1.242 0-0.185-0.016-0.366-0.047-0.542l0.003 0.019c-0.092-0.155-0.34-0.247-0.712-0.434z"></path>
          </svg>
          <span class="tooltip-text">Comptes WhatsApp</span>
        </div>

        <div v-if="!scopedSession" class="nav-item" :class="{ 'active': $route.path.includes('/dashboard/whatsapp/broadcast') }" title="Broadcast" @click="proGuard(handleBroadcastClick)" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M4 11a9 9 0 0 1 9 9"></path>
            <path d="M4 4a16 16 0 0 1 16 16"></path>
            <circle cx="5" cy="19" r="1"></circle>
          </svg>
          <span class="tooltip-text">Broadcast</span>
        </div>

        <router-link v-if="!scopedSession" to="/dashboard/instagram" class="nav-item" :class="{ 'active': $route.path.startsWith('/dashboard/instagram') }" title="Instagram" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="2" width="20" height="20" rx="5" ry="5"></rect>
            <path d="M16 11.37A4 4 0 1 1 12.63 8 4 4 0 0 1 16 11.37z"></path>
            <line x1="17.5" y1="6.5" x2="17.51" y2="6.5"></line>
          </svg>
          <span class="tooltip-text">Instagram</span>
        </router-link>

        <router-link style="display: none;" to="/dashboard/analytics" display="none" class="nav-item" :class="{ 'active': $route.path === '/dashboard/analytics' }" title="Analytics" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 20V10M18 20V4M6 20v-6" />
          </svg>
          <span class="tooltip-text">Analytics</span>
        </router-link>

        <router-link to="/dashboard/transactions" style="display: none;" class="nav-item" :class="{ 'active': $route.path === '/dashboard/transactions' }" title="Transactions" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="10" />
            <path d="M12 6v6l4 2" />
          </svg>
          <span class="tooltip-text">Transactions</span>
        </router-link>

        <router-link to="/dashboard/orders" style="display: none;" class="nav-item" :class="{ 'active': $route.path === '/dashboard/orders' }" title="Commandes" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M9 17l-5-5 5-5M20 17l-5-5 5-5" />
          </svg>
          <span class="tooltip-text">Commandes</span>
        </router-link>

        <div v-if="!scopedSession" class="nav-item" :class="{ 'active': $route.path === '/dashboard/all-users' || /\/dashboard\/chatbots\/[^/]+\/home/.test($route.path) }" title="Abonnés" @click="handleSubscribersClick" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2M12 7a4 4 0 100-8 4 4 0 000 8z" />
          </svg>
          <span class="tooltip-text">Abonnés</span>
        </div>

        <!-- Admin Panel - Only visible for mamadou.dieye@peelo.chat -->
        <router-link 
          v-if="isAdminUser" 
          to="/dashboard/admin" 
          class="nav-item" 
          :class="{ 'active': $route.path === '/dashboard/admin' }" 
          title="Administration" 
          @mouseenter="showTooltip" 
          @mouseleave="hideTooltip"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4z"/>
            <path d="M9 12l2 2 4-4"/>
          </svg>
          <span class="tooltip-text">Administration</span>
        </router-link>

        <!-- Voix wolof : jauge du crédit Google, réservée au superadmin -->
        <router-link
          v-if="isAdminUser"
          to="/dashboard/voix-wolof"
          class="nav-item"
          :class="{ 'active': $route.path === '/dashboard/voix-wolof' }"
          title="Voix wolof"
          @mouseenter="showTooltip"
          @mouseleave="hideTooltip"
        >
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M12 1a3 3 0 0 0-3 3v8a3 3 0 0 0 6 0V4a3 3 0 0 0-3-3z"/>
            <path d="M19 10v2a7 7 0 0 1-14 0v-2"/>
            <path d="M12 19v4"/>
          </svg>
          <span class="tooltip-text">Voix wolof</span>
        </router-link>

        <div class="nav-divider"></div>

        <button v-if="!scopedSession" @click="proGuard(navigateToEcommerce)" class="nav-item nav-external" title="E-commerce Dashboard" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="8" cy="21" r="1"/>
            <circle cx="19" cy="21" r="1"/>
            <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12"/>
          </svg>
          <span class="tooltip-text">Peelo-shop</span>
        </button>

        <a v-if="!scopedSession" href="https://console.peelo.io/" target="_blank" class="nav-item nav-external" title="Console API" @click.prevent="proGuard(goConsoleApi)" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="4" width="20" height="16" rx="3" />
            <path d="M7 8l4 4-4 4" />
            <path d="M13 16h4" />
          </svg>
          <span class="tooltip-text">Console API</span>
        </a>

        <router-link to="/dashboard/payouts" style="display: none;"  class="nav-item" :class="{ 'active': $route.path === '/dashboard/payouts' }" title="Paiements" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <rect x="2" y="5" width="20" height="14" rx="2" />
            <line x1="2" y1="10" x2="22" y2="10" />
          </svg>
          <span class="tooltip-text">Paiements</span>
        </router-link>
      </nav>

      <!-- Bottom tools -->
      <div class="bottom-tools">
        <button class="theme-toggle" @click="$emit('toggle-theme')" title="Changer de thème" @mouseenter="showTooltip" @mouseleave="hideTooltip">
          <svg v-if="!isDarkMode" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <circle cx="12" cy="12" r="5" />
            <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
          </svg>
          <svg v-else width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
            <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
          </svg>
          <span class="tooltip-text">{{ isDarkMode ? 'Mode jour' : 'Mode nuit' }}</span>
        </button>
      </div>



    <!-- Mobile Overlay for closing -->
    <div 
      v-if="isMobile && mobileIsOpen" 
      class="mobile-overlay"
      @click="$emit('close-mobile')"
    ></div>

    <!-- Mobile Hamburger Button (Only visible on mobile) -->
    <Teleport to="body">
      <div class="mobile-toggle-container" v-if="isMobile && !mobileIsOpen">
          <button class="mobile-toggle-btn" @click="$emit('open-mobile')">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <line x1="3" y1="12" x2="21" y2="12"></line>
              <line x1="3" y1="6" x2="21" y2="6"></line>
              <line x1="3" y1="18" x2="21" y2="18"></line>
            </svg>
          </button>
      </div>
    </Teleport>

      <!-- Profile section -->
      <div class="profile-section">
        <!-- Subscription Badge (Always Visible) -->
        <div class="sidebar-subscription-badge" :class="subscriptionClass">
          <span class="badge-text">{{ shortSubscriptionName }}</span>
        </div>
        <button class="profile-button" @click="toggleUserMenu">
          <img :src="getUserAvatar(user)" alt="Profile">
          <!-- Profile Info (Visible on Mobile) -->
          <div class="profile-info">
             <span class="profile-name">{{ user?.name || user?.data?.name || 'Utilisateur' }}</span>
             <span class="profile-email">{{ user?.email || user?.data?.email || '' }}</span>
          </div>
          <div v-if="subscriptionClass !== 'free'" class="verified-badge">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="verified-icon">
              <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke-width="2" />
            </svg>
          </div>
        </button>
      </div>
    </aside>



    <!-- User Menu Popup au niveau racine -->
    <div v-if="showUserMenu" class="user-menu">
       <div class="user-info">
        <img :src="getUserAvatar(user)" alt="Profile" class="menu-avatar">
        <div class="user-details">
          <span class="user-name">{{ user?.name || 'Utilisateur' }}</span>
          <span class="user-email">{{ user?.email || 'utilisateur@mail.com' }}</span>
        </div>
        <div v-if="subscriptionClass !== 'free'" class="verified-badge blue">
          <svg width="14" height="14" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="verified-icon">
            <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke-width="2" />
          </svg>
        </div>
      </div>
      <!-- Subscription Badge -->
      <div class="subscription-badge" :class="subscriptionClass">
        <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
        </svg>
        <span>{{ subscriptionName }}</span>
        <a v-if="!userSubscription" href="#" @click.prevent="$emit('open-upgrade-modal')" class="upgrade-link">Upgrade</a>
      </div>
      <div class="menu-items">
        <div class="menu-item" style="cursor: default; opacity: 0.6;">
          <div class="menu-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/>
              <circle cx="12" cy="7" r="4"/>
            </svg>
          </div>
          <span>Voir profil</span>
        </div>
        <div class="menu-item" @click="proGuard(goToTeam)">
          <div class="menu-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/>
              <circle cx="9" cy="7" r="4"/>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75"/>
            </svg>
          </div>
          <span>Gérer l'équipe &amp; le partage</span>
          <span v-if="isFreePlan" class="menu-pro-badge">Pro</span>
        </div>
        <div class="menu-item" @click="goToAccountSettings" v-if="false">
          <div class="menu-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
            </svg>
          </div>
          <span>Paramètres du compte</span>
        </div>
        <div class="menu-item" @click="$emit('toggle-theme')">
          <div class="menu-icon">
            <svg v-if="!isDarkMode" width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <circle cx="12" cy="12" r="5" />
              <path d="M12 1v2M12 21v2M4.22 4.22l1.42 1.42M18.36 18.36l1.42 1.42M1 12h2M21 12h2M4.22 19.78l1.42-1.42M18.36 5.64l1.42-1.42" />
            </svg>
            <svg v-else width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M21 12.79A9 9 0 1111.21 3 7 7 0 0021 12.79z" />
            </svg>
          </div>
          <span>{{ isDarkMode ? 'Mode jour' : 'Mode nuit' }}</span>
        </div>
        <div class="menu-item" @click="logout">
          <div class="menu-icon">
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M9 21H5a2 2 0 01-2-2V5a2 2 0 012-2h4"/>
              <polyline points="16 17 21 12 16 7"/>
              <line x1="21" y1="12" x2="9" y2="12"/>
            </svg>
          </div>
          <span>Déconnexion</span>
        </div>
      </div>

      <!-- Bascule entre mon compte et les comptes partagés + gestion de l'équipe -->
      <AccountSwitcher />

    </div>

    <!-- Modal pour sélectionner un agent (Griot AI) -->
    <Teleport to="body">
      <div v-if="showAgentSelectionModal" class="modal-overlay" :class="{ 'dark-mode': isDarkMode }" @click.self="closeAgentModal">
        <div class="modal-content premium-modal">
          <div class="modal-header">
            <h3>Sélectionner un Agent</h3>
            <button class="close-btn" @click="closeAgentModal">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                <circle cx="12" cy="12" r="10" stroke-opacity="0.1" />
                <path d="M15 9l-6 6M9 9l6 6" />
              </svg>
            </button>
          </div>
          
          <div class="modal-body">
            <div class="search-container">
               <div class="search-input-wrapper">
                  <input 
                    type="text" 
                    v-model="agentSearchQuery" 
                    placeholder="Rechercher un agent..."
                    class="premium-search-input"
                  >
                  <svg class="search-icon" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                     <circle cx="11" cy="11" r="8"></circle>
                     <line x1="21" y1="21" x2="16.65" y2="16.65"></line>
                  </svg>
               </div>
            </div>

            <p class="modal-subtitle">Agents disponibles</p>
            
            <div v-if="loadingAgents" class="loading-state">
              <div class="spinner"></div>
              Chargement...
            </div>

            <div v-else class="agents-list premium-list">
              <div 
                v-for="agent in filteredAgentList" 
                :key="agent._id" 
                class="agent-item premium-item"
              >
                  <div class="agent-avatar-wrapper">
                   <div class="agent-avatar">
                      <!-- Placeholder avatar or image if available -->
                      <img v-if="getChatbotAvatar(agent)" :src="getChatbotAvatar(agent)" :alt="agent.bot_name" class="avatar-img" @error="handleAvatarError($event, agent)" />
                      <span v-else>{{ agent.bot_name.charAt(0).toUpperCase() }}</span>
                   </div>
                   <div class="agent-status-dot" :class="agent.status === 'active' ? 'active' : 'inactive'"></div>
                </div>

                <div class="agent-info">
                  <span class="agent-name">{{ agent.bot_name }}</span>
                  <span class="agent-email">{{ agent.email || 'Aucun email associé' }}</span>
                </div>
                
                <button class="select-agent-btn" @click="selectAgentForGriot(agent._id)">
                  Sélectionner
                </button>
              </div>
              
              <div v-if="filteredAgentList.length === 0" class="empty-search">
                 Aucun agent trouvé
              </div>
            </div>
          </div>
        </div>
      </div>
    </Teleport>

    <!-- Modal de félicitations affiché 1x au passage Free -> Pro -->
    <ProWelcomeModal :show="showProWelcome" @close="showProWelcome = false" />
  </div>
</template>

<script>
import { useRouter, useRoute } from 'vue-router';
import { computed, ref, watch, onMounted } from 'vue';
import { ecommerceDashboardUrl, apiBaseUrl } from '@/config';
import logoWhite from '@/assets/logo-white.png';
import axios from 'axios';
import ProWelcomeModal from './ProWelcomeModal.vue';
import AccountSwitcher from './AccountSwitcher.vue';
import { syncSsoCookieFromStorage } from '@/utils/ssoCookie';
import { isScopedSession } from '@/utils/accountSwitch';

export default {
  name: 'Sidebar',
  components: { ProWelcomeModal, AccountSwitcher },
  props: {
    isDarkMode: {
      type: Boolean,
      default: false
    },
    user: {
      type: Object,
      default: null
    },
    mobileIsOpen: {
      type: Boolean,
      default: false
    }
  },
  emits: ['toggle-sidebar', 'logout', 'toggle-theme', 'close-mobile', 'open-upgrade-modal'],
  setup(props, { emit }) {
    const route = useRoute();
    const router = useRouter();
    const showUserMenu = ref(false);
    const isExpanded = ref(false);
    const isMobile = ref(false);


    // Check mobile state
    const checkMobile = () => {
      if (typeof window !== 'undefined') {
        isMobile.value = window.innerWidth <= 768;
      }
    };

    if (typeof window !== 'undefined') {
      window.addEventListener('resize', checkMobile);
      checkMobile();
    }

    // Auto-close sidebar on route change (Mobile only)
    watch(
      () => route.path,
      () => {
        if (isMobile.value && props.mobileIsOpen) {
           emit('close-mobile');
        }
      }
    );
    
    // Griot AI states
    const showAgentSelectionModal = ref(false);
    const agentList = ref([]);
    const loadingAgents = ref(false);
    const agentSearchQuery = ref('');
    
    // Filtered Agents
    const filteredAgentList = computed(() => {
        if (!agentSearchQuery.value) return agentList.value;
        const query = agentSearchQuery.value.toLowerCase();
        return agentList.value.filter(agent => 
            agent.bot_name.toLowerCase().includes(query) || 
            (agent.email && agent.email.toLowerCase().includes(query))
        );
    });

    const logoSrc = computed(() => {
      return props.isDarkMode 
        ? logoWhite 
        : 'https://peelo.io/assets/img/peelo/v2.png';
    });

    // Plan rafraîchi en direct depuis le backend (au montage) : évite d'afficher un plan
    // périmé issu du localStorage posé au login (ex: l'utilisateur vient de passer en Pro).
    const livePlan = ref(null);
    const showProWelcome = ref(false); // modal "Bienvenue en Pro" (affiché 1x à la détection Free->Pro)
    const isFreePlan = ref(false); // gating des fonctionnalités réservées au Pro dans la sidebar

    // Garde Pro : en Free, ouvre la modale d'abonnement (gérée par le parent) au lieu d'agir.
    const proGuard = (action) => {
      if (isFreePlan.value) { emit('open-upgrade-modal'); return; }
      if (typeof action === 'function') action();
    };
    const goWhatsApp = () => router.push('/dashboard/whatsapp-signup');
    const goConsoleApi = () => {
      // SSO : (re)dépose le cookie de session juste avant d'ouvrir le console,
      // pour qu'il reconnaisse l'utilisateur sans redemander une connexion.
      syncSsoCookieFromStorage();
      window.open('https://console.peelo.io/', '_blank');
    };

    // Subscription computed properties
    const userSubscription = computed(() => {
      // Priorité au plan live rafraîchi depuis le backend.
      if (livePlan.value) return livePlan.value;

      // Check multiple possible locations for subscription/plan info
      const planInfo = props.user?.subscription ||
                       props.user?.data?.subscription ||
                       props.user?.plan ||
                       props.user?.data?.plan;
                       
      // If it's just a string (e.g. "pro"), wrap it in a slug object for compatibility
      if (typeof planInfo === 'string') {
        return { slug: planInfo, name: planInfo.charAt(0).toUpperCase() + planInfo.slice(1) };
      }
      
      return planInfo || null;
    });

    // Au montage : rafraîchir le plan réel depuis le backend (le localStorage du login
    // peut être périmé, ex: l'utilisateur vient de payer et de passer en Pro).
    const refreshLivePlan = async () => {
      try {
        const raw = JSON.parse(localStorage.getItem('user') || '{}');
        const token = (raw && raw.data && raw.data.token) || raw.token || localStorage.getItem('token');
        if (!token) return;
        const rawTarget = (raw && raw.data) ? raw.data : raw;
        const prevSlug = (rawTarget && rawTarget.subscription && rawTarget.subscription.plan_slug) || (rawTarget && rawTarget.plan) || 'connect';
        const { data } = await axios.get(`${apiBaseUrl}/strong/billing/my-plan`, {
          headers: { Authorization: `Bearer ${token}` }
        });
        if (data && data.success && data.plan_slug) {
          // livePlan ne représente qu'un abonnement PAYANT : pour Free (connect) on laisse
          // null -> affichage "Plan Gratuit" + lien Upgrade (comportement d'origine).
          livePlan.value = (data.plan_slug !== 'connect')
            ? { plan_slug: data.plan_slug, plan_name: data.plan_name, slug: data.plan_slug, name: data.plan_name }
            : null;
          isFreePlan.value = (data.plan_slug === 'connect');
          // Transition Free -> Pro détectée à ce chargement : modal de félicitations (1x).
          if (prevSlug !== 'smart_agent' && data.plan_slug === 'smart_agent') {
            showProWelcome.value = true;
          }
          // Met à jour le localStorage pour que les autres écrans voient le bon plan.
          try {
            const u = JSON.parse(localStorage.getItem('user') || '{}');
            const target = u.data ? u.data : u;
            target.subscription = { ...(target.subscription || {}), plan_slug: data.plan_slug, plan_name: data.plan_name };
            target.plan = data.plan_slug;
            localStorage.setItem('user', JSON.stringify(u));
          } catch (_) { /* ignore */ }
        }
      } catch (_) { /* silencieux : fallback sur le plan du localStorage */ }
    };
    onMounted(refreshLivePlan);

    const subscriptionName = computed(() => {
      if (!userSubscription.value) return 'Plan Gratuit';
      const plan = userSubscription.value;
      
      // Prioritize plan_name as it's the more descriptive field from Jarvis
      if (plan.plan_name) return plan.plan_name;
      
      const name = plan.name || plan.plan_slug || plan.slug || '';
      
      if (name.toLowerCase().includes('enterprise') || name.toLowerCase().includes('entreprise')) {
        return 'Entreprise';
      }
      if (name.toLowerCase().includes('pro')) {
        return 'Plan Pro';
      }
      return name || 'Plan Actif';
    });

    const subscriptionClass = computed(() => {
      if (!userSubscription.value) return 'free';
      const plan = userSubscription.value;
      const slug = (plan.plan_slug || plan.slug || '').toLowerCase();
      const name = (plan.plan_name || plan.name || '').toLowerCase();

      if (slug.includes('enterprise') || name.includes('enterprise') || name.includes('entreprise')) return 'enterprise';
      if (slug.includes('pro') || name.includes('pro')) return 'pro';
      return 'free';
    });

    const shortSubscriptionName = computed(() => {
      const sType = subscriptionClass.value;
      if (sType === 'enterprise' || sType === 'pro') return 'Pro';
      return 'Free';
    });
    // Helper for Avatar URL
    const getChatbotAvatar = (agent) => {
      // Handle legacy default avatar path
      if (agent.avatar === '/avatars/bot1.png') {
        // Use a nice default bot avatar (e.g. DiceBear)
        // Using bottts-neutral which is clean and professional
        return `https://api.dicebear.com/9.x/bottts-neutral/svg?seed=${agent._id || agent.bot_name}`;
      }
      
      // Standard avatar
      if (agent.avatar) {
        // Check if it's already a full URL (in case of legacy data)
        if (agent.avatar.startsWith('http')) {
          return agent.avatar;
        }
        return `https://api.peelo.io/public/${agent.avatar}`;
      }
      
      // Return null to fallback to the default icons (like WhatsApp icon)
      return null;
    };

    const handleAvatarError = (event, agent) => {
        // Fallback to initial if image fails to load
        agent.avatar = ''; 
    };

    // User Avatar Logic
    const getUserAvatar = (userData) => {
        // Extract user info safely
        const user = userData?.data || userData || {};
        const profilePic = user.profile_picture;
        
        // Check if profile picture exists and is NOT a placeholder
        if (profilePic && 
            profilePic !== 'null' && 
            profilePic !== 'undefined' && 
            !profilePic.includes('placehold.co')) {
            return profilePic;
        }
        
        // Use DiceBear 'micah' or 'adventurer-neutral' for polished human avatars
        // Using 'micah' for a clean, modern artistic look
        const seed = user.name || user.email || 'user';
        return `https://api.dicebear.com/9.x/micah/svg?seed=${encodeURIComponent(seed)}&backgroundColor=e0e7ff`;
    };

    // Determine if we're on a chatbot page
    const isChatbotPage = computed(() => {
      // Exclude home page from "Agents" highlight because it's now handled by "Abonnés"
      if (route.path.match(/\/dashboard\/chatbots\/[^/]+\/home/)) {
        return false;
      }
      return route.path.includes('/dashboard/chatbots/') && route.params.id;
    });

    // Get the chatbot IDmerc
    const chatbotId = computed(() => {
      return route.params.id;
    });

    // Check if user is admin
    const isAdminUser = computed(() => {
      try {
        // Vérifier dans localStorage en priorité
        const storedUser = JSON.parse(localStorage.getItem('user') || '{}');
        const storedEmail = storedUser.data?.email;
        
        if (storedEmail === 'mamadou.dieye@peelo.chat') {
          return true;
        }
        
        // Fallback: vérifier dans les props
        const userEmail = props.user?.data?.email || props.user?.email;
        return userEmail === 'mamadou.dieye@peelo.chat';
      } catch (e) {
        return false;
      }
    });

    // Toggle user menu
    const toggleUserMenu = () => {
      showUserMenu.value = !showUserMenu.value;
    };

    // Toggle sidebar
    const toggleSidebar = () => {
      isExpanded.value = !isExpanded.value;
      localStorage.setItem('sidebarExpanded', isExpanded.value);
      emit('toggle-sidebar', isExpanded.value);
    };

    // Tooltips positioning
    const showTooltip = (event) => {
      const tooltip = event.currentTarget.querySelector('.tooltip-text');
      if (tooltip) {
        const rect = event.currentTarget.getBoundingClientRect();
        
        // Position fixe pour être toujours au-dessus de tous les éléments
        tooltip.style.position = 'fixed';
        
        // Si la barre latérale est étendue, positionner les tooltips plus à droite
        if (isExpanded.value) {
          // Position à droite de la barre latérale étendue (64px sidebar + 240px expanded + 10px marge)
          tooltip.style.left = `314px`;
        } else {
          // Position normale à droite de l'élément
          tooltip.style.left = `${rect.right + 10}px`;
        }
        
        // La position verticale reste la même
        tooltip.style.top = `${rect.top + (rect.height / 2)}px`;
        
        // Ajouter la classe visible
        tooltip.classList.add('visible');
      }
    };

    const hideTooltip = (event) => {
      const tooltip = event.currentTarget.querySelector('.tooltip-text');
      if (tooltip) {
        tooltip.classList.remove('visible');
      }
    };

    // Logout function
    const logout = () => {
      localStorage.removeItem('token');
      router.push('/login');
      emit('logout');
      showUserMenu.value = false;
    };

    // Close user menu when clicking outside - Version optimisée
    let clickOutsideHandler = null;
    
    if (typeof window !== 'undefined') {
      clickOutsideHandler = (e) => {
        const menu = document.querySelector('.user-menu');
        const button = document.querySelector('.profile-button');
        if (showUserMenu.value && menu && !menu.contains(e.target) && button && !button.contains(e.target)) {
          showUserMenu.value = false;
        }
      };
      window.addEventListener('click', clickOutsideHandler);
    }

    // Watch for route changes to close the user menu - Version optimisée
    watch(
      () => route.path,
      () => {
        showUserMenu.value = false;
      },
      { flush: 'post' } // Évite les boucles de watchers
    );

    // New methods for profile navigation
    const goToProfile = () => {
      router.push('/dashboard/profile');
      showUserMenu.value = false;
    };

    // Équipe & partage de compte (réservé au Pro : proGuard gère le cas Free).
    const goToTeam = () => {
      router.push('/dashboard/team');
      showUserMenu.value = false;
    };

    const goToAccountSettings = () => {
      router.push('/dashboard/account-settings');
      showUserMenu.value = false;
    };

    const navigateToEcommerce = () => {
      // Récupérer les données utilisateur depuis localStorage
      const userData = localStorage.getItem('user');
      if (!userData) {
        //console.error('Données utilisateur non trouvées');
        // Rediriger vers l'e-commerce sans données
        window.open(ecommerceDashboardUrl, '_blank');
        return;
      }
      
      try {
        // Importer la fonction de cryptage
        import('@/utils/crypto.js').then(({ encryptUserData }) => {
          // Crypter les données utilisateur
          const encryptedData = encryptUserData(userData);
          
          // Construire l'URL avec les données cryptées
          const autoconnectUrl = `${ecommerceDashboardUrl}/#/autoconnect/${encryptedData}`;
          
          //console.log('🔗 Redirection vers l\'e-commerce avec auto-login sécurisé');
          window.open(autoconnectUrl, '_blank');
        }).catch(error => {
          //console.error('Erreur lors du cryptage des données:', error);
          // Fallback sans cryptage
          window.open(ecommerceDashboardUrl, '_blank');
        });
      } catch (error) {
        //console.error('Erreur lors de la préparation de la redirection:', error);
        // Fallback sans cryptage
        window.open(ecommerceDashboardUrl, '_blank');
      }
    };

    const targetAction = ref('griot'); // 'griot' or 'broadcast'

    // Generic Fetch Agents Helper
    const fetchAgents = async () => {
         const userData = localStorage.getItem('user');
         if (!userData) return [];
         
         const token = JSON.parse(userData).data.token;
         
         const response = await axios.get(`${apiBaseUrl}/get/list/chatbots`, {
           headers: { 'Authorization': `Bearer ${token}` }
         });

         return response.data.chatbots || [];
    };

    // Generic Agent Selection Logic
    const handleAgentSelectionForAction = async (action) => {
      try {
        loadingAgents.value = true;
        targetAction.value = action;
        
        const agents = await fetchAgents();
        
        if (agents.length === 0) {
            // Pas d'agent, redirection par défaut
            if (action === 'broadcast') router.push('/dashboard/whatsapp/broadcast');
            else if (action === 'playground') router.push('/dashboard/chatbots');
            else if (action === 'appel') window.location.href = appelUrl();
            else router.push('/dashboard/chatbots');
            
        } else if (agents.length === 1) {
            // Un seul agent, redirection directe
            const id = agents[0]._id;
            if (action === 'appel') { window.location.href = appelUrl(id); return; }
            if (action === 'broadcast') router.push(`/dashboard/whatsapp/broadcast?idbot=${id}`);
            else if (action === 'playground') router.push(`/dashboard/chatbots/${id}/playground`);
            else router.push(`/dashboard/chatbots/${id}/griot-builder`);
            
        } else {
            // Plusieurs agents, afficher modal
            agentList.value = agents;
            showAgentSelectionModal.value = true;
        }

      } catch (error) {
        // Fallback
        if (action === 'broadcast') router.push('/dashboard/whatsapp/broadcast');
        else if (action === 'playground') router.push('/dashboard/chatbots');
        else router.push('/dashboard/chatbots');
      } finally {
        loadingAgents.value = false;
      }
    };

    // Griot AI Logic
    const handleGriotClick = () => handleAgentSelectionForAction('griot');
    
    // Playground Logic
    const handlePlaygroundClick = () => handleAgentSelectionForAction('playground');

    // Appels vocaux : la page d'appel vit sur la même origine (/appel/), elle lit la session du dashboard.
    const appelUrl = (id) => `${window.location.origin}/appel/${id ? '?idbot=' + id : ''}`;
    const handleAppelClick = () => handleAgentSelectionForAction('appel');
    
    // Broadcast Logic
    const handleBroadcastClick = () => handleAgentSelectionForAction('broadcast');

    const closeAgentModal = () => {
        showAgentSelectionModal.value = false;
    };

    const selectAgentForGriot = (id) => {
        showAgentSelectionModal.value = false;
        if (targetAction.value === 'appel') {
            window.location.href = appelUrl(id);
        } else if (targetAction.value === 'broadcast') {
            router.push(`/dashboard/whatsapp/broadcast?idbot=${id}`);
        } else if (targetAction.value === 'playground') {
            router.push(`/dashboard/chatbots/${id}/playground`);
        } else {
            router.push(`/dashboard/chatbots/${id}/griot-builder`);
        }
    };

    const handleSubscribersClick = async () => {
      try {
        const userData = localStorage.getItem('user');
        if (!userData) return;
        
        const token = JSON.parse(userData).data.token;
        
        const response = await axios.get(`${apiBaseUrl}/get/list/chatbots`, {
          headers: { 'Authorization': `Bearer ${token}` }
        });

        const agents = response.data.chatbots || [];
        
        if (agents.length === 1) {
            router.push(`/dashboard/chatbots/${agents[0]._id}/home`);
        } else {
            router.push('/dashboard/chatbots');
        }

      } catch (error) {
        router.push('/dashboard/chatbots');
      }
    };

    return {
      isChatbotPage,
      chatbotId,
      isAdminUser,
      showUserMenu,
      toggleUserMenu,
      isExpanded,
      toggleSidebar,
      logout,
      showTooltip,
      hideTooltip,
      goToProfile,
      goToTeam,
      isFreePlan,
      // Session déléguée limitée à certains agents : masque les sections « compte »
      // (le backend les bloque de toute façon ; ici on évite juste des clics morts).
      scopedSession: isScopedSession(),
      goToAccountSettings,
      navigateToEcommerce,
      // Griot AI
      handleGriotClick,
      handlePlaygroundClick,
      handleAppelClick,
      handleBroadcastClick,
      showAgentSelectionModal,
      agentList,
      loadingAgents,
      closeAgentModal,
      selectAgentForGriot,
      agentSearchQuery,
      filteredAgentList,
      getChatbotAvatar,
      getUserAvatar,
      handleAvatarError,
      handleSubscribersClick,
      isMobile,
      // Subscription
      userSubscription,
      subscriptionName,
      subscriptionClass,
      shortSubscriptionName,
      showProWelcome,
      proGuard,
      goWhatsApp,
      goConsoleApi,
      logoSrc
    };
  }
};
</script>

<style scoped>
/* Base container */
.sidebar-container {
  display: flex;
  height: 100vh;
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  z-index: 1000;
  transition: transform 0.3s ease;
}

@media (max-width: 768px) {
  .sidebar-container {
    pointer-events: none; /* Allow clicking through when hidden */
  }
  
  .sidebar {
    display: none; /* Hide compact sidebar on mobile */
  }

  .expanded-sidebar {
    pointer-events: auto;
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 280px;
    z-index: 1001;
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 2px 0 8px rgba(0,0,0,0.15);
  }

  .expanded-sidebar.mobile-open {
    transform: translateX(0);
  }
}

/* Premium Modal Styles */
.premium-modal {
  max-width: 480px;
  border-radius: 16px;
  box-shadow: 0 10px 40px rgba(0, 0, 0, 0.1);
  padding: 0;
  overflow: visible;
  background: #FFFFFF;
  transition: all 0.3s ease;
}

.modal-overlay.dark-mode .premium-modal {
    background: #0A1A16;
    border: 1px solid rgba(255,255,255,0.1);
    box-shadow: 0 10px 40px rgba(0, 0, 0, 0.5);
}

.modal-header {
  padding: 24px 24px 16px;
  border-bottom: none;
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.modal-header h3 {
  font-size: 20px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.modal-overlay.dark-mode .modal-header h3 {
    color: #FFFFFF;
}

.close-btn {
  color: #9CA3AF;
  transition: color 0.2s;
  padding: 4px;
}

.modal-overlay.dark-mode .close-btn {
    color: #4B5563;
    opacity: 0.8;
}

.close-btn:hover {
  color: #4B5563;
}

.modal-overlay.dark-mode .close-btn:hover {
    color: #FFFFFF;
    opacity: 1;
}

.modal-subtitle {
  padding: 0 24px;
  margin-bottom: 12px;
  font-size: 13px;
  font-weight: 500;
  color: #6B7280;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.modal-overlay.dark-mode .modal-subtitle {
    color: #9CA3AF;
}

/* Nav Divider */
/* ... existing Divider styles ... */

/* Search Input Style */
.search-container {
  padding: 0 24px 24px;
}

.search-input-wrapper {
  position: relative;
}

.premium-search-input {
  width: 100%;
  padding: 12px 16px;
  padding-right: 40px;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  font-size: 14px;
  color: #111827;
  background: white;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
  box-sizing: border-box; /* IMPORTANT */
}

.modal-overlay.dark-mode .premium-search-input {
    background: rgba(255, 255, 255, 0.05);
    border-color: rgba(218, 255, 209, 0.2);
    color: #FFFFFF;
}

.modal-overlay.dark-mode .premium-search-input::placeholder {
    color: rgba(255, 255, 255, 0.4);
}

.premium-search-input:focus {
  outline: none;
  border-color: #3B82F6;
  box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
}

.search-icon {
  position: absolute;
  right: 12px;
  top: 50%;
  transform: translateY(-50%);
  color: #9CA3AF;
  pointer-events: none;
}

.modal-overlay.dark-mode .search-icon {
    color: #daffd1;
}

/* List Styles */
.premium-list {
  padding: 0 24px 24px;
  gap: 16px;
  max-height: 320px;
}

.premium-item {
  display: flex;
  align-items: center;
  padding: 0;
  border: none;
  background: none;
  border-radius: 0;
  cursor: default; /* Action is on button now */
}

.premium-item:hover {
  background: none;
  border-color: transparent;
}

.modal-overlay.dark-mode .agent-item.premium-item:hover {
    background: rgba(218, 255, 209, 0.1);
}

.agent-avatar-wrapper {
  position: relative;
  margin-right: 16px;
}

/* ... existing styles ... */

.agent-name {
  font-weight: 600;
  font-size: 15px;
  color: #111827;
}

.modal-overlay.dark-mode .agent-name {
    color: #FFFFFF;
}

.agent-email {
  font-size: 13px;
  color: #6B7280;
}

.modal-overlay.dark-mode .agent-email {
    color: #daffd1;
    opacity: 0.7;
}

.select-agent-btn {
  padding: 8px 16px;
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 500;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
}

.modal-overlay.dark-mode .select-agent-btn {
    background: rgba(255,255,255,0.1);
    border-color: rgba(255,255,255,0.2);
    color: #FFFFFF;
}

.select-agent-btn:hover {
  background: #F9FAFB;
  border-color: #D1D5DB;
  color: #111827;
}

.modal-overlay.dark-mode .select-agent-btn:hover {
    background: rgba(255,255,255,0.2);
    border-color: rgba(255,255,255,0.3);
}

.empty-search {
  text-align: center;
  color: #9CA3AF;
  font-size: 14px;
  padding: 20px 0;
}


@keyframes slideIn {
  from { opacity: 0; transform: translateY(10px); }
  to { opacity: 1; transform: translateY(0); }
}

.loading-state {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 20px;
  color: #6B7280;
}

.spinner {
  width: 20px;
  height: 20px;
  border: 2px solid #E5E7EB;
  border-top-color: #3B82F6;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  to { transform: rotate(360deg); }
}

/* Compact sidebar */
.sidebar {
  /* Variables from GriotBuilderView */
  --peelo-green: #143028;
  --peelo-accent: #DAFFD1;
  --hover-bg: rgba(20, 48, 40, 0.04);
  --text-color: #143028;
  
  width: 64px;
  height: 100vh;
  background: white;
  border-right: 1px solid #E5E7EB;
  display: flex;
  flex-direction: column;
  padding: 12px 0;
  gap: 12px; /* Added gap from Griot */
  z-index: 10;
}

.sidebar.dark-mode {
  --hover-bg: rgba(255, 255, 255, 0.08); /* Dark mode hover */
  background: #0A1A16; /* Griot Dark Bg */
  border-right-color: rgba(255, 255, 255, 0.05); /* Griot Dark Border */
}

/* Logo */
.logo-icon {
  width: 48px; /* Matched Griot */
  height: 48px; /* Matched Griot */
  margin: 0 auto 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: white; /* Logo blanc en mode jour */
  border-radius: 16px; /* Matched Griot */
  border: 1px solid #E5E7EB;
  cursor: pointer;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.sidebar.dark-mode .logo-icon {
  background: rgba(218, 255, 209, 0.1);
  border-color: transparent;
  color: #DAFFD1;
}

.logo-icon img {
  width: 24px;
  height: 24px;
  object-fit: contain;
}

/* Navigation menu */
.nav-menu {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 12px;
  flex: 1;
  overflow-y: auto;
}

.nav-item {
  position: relative;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: none;
  background: transparent;
  color: #143028;
  text-decoration: none;
  opacity: 0.8;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}



.nav-item:hover {
  background: var(--peelo-green);
  color: white !important;
  opacity: 1;
}

.nav-item.active {
    background: var(--peelo-green); 
    color: white !important; 
    opacity: 1; 
    transform: scale(1.05);
    box-shadow: 0 5px 15px -5px rgba(0,0,0,0.2);
}

/* External Link Specifics */
.nav-item.nav-external {
  border: 1px solid #E5E7EB;
  opacity: 1;
}

.nav-item.nav-external:hover {
  border-color: #D1D5DB;
  color: inherit;
}

/* Dark Mode Overrides */
.sidebar.dark-mode .nav-item {
  color: white;
  background: transparent; /* Reset light mode background */
}

.sidebar.dark-mode .nav-item:hover {
  background: var(--peelo-accent);
  color: var(--peelo-green) !important;
}

.sidebar.dark-mode .nav-item.active {
   background: var(--peelo-accent); 
   color: var(--peelo-green) !important;
   box-shadow: 0 0 15px rgba(218, 255, 209, 0.2);
}

.sidebar.dark-mode .nav-item.nav-external {
  border-color: rgba(255, 255, 255, 0.05);
}

/* Bottom tools */
.bottom-tools {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 0 12px;
  margin-top: 12px;
  margin-bottom: 12px;
}

.theme-toggle,
.settings-button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: none;
  background: rgba(20, 48, 40, 0.04); /* Requested background only for these tools */
  color: #143028; /* Peelo Green */
  border-radius: 10px; 
  opacity: 1; /* Fully opaque for these buttons */
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.16, 1, 0.3, 1);
}



.theme-toggle:hover,
.settings-button:hover {
  background: var(--peelo-green);
  opacity: 1;
  color: white !important;
}

.sidebar.dark-mode .theme-toggle,
.sidebar.dark-mode .settings-button {
  color: white;
  background: transparent; /* Reset light mode background */
}

.sidebar.dark-mode .theme-toggle:hover,
.sidebar.dark-mode .settings-button:hover {
  background-color: var(--hover-bg);
  color: #FFFFFF;
}


/* Profile section */
.profile-section {
  padding: 0 12px;
  position: static;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

/* Sidebar Subscription Badge (Always Visible) */
.sidebar-subscription-badge {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 4px 8px;
  border-radius: 6px;
  font-size: 10px;
  font-weight: 600;
  width: 100%;
  max-width: 64px;
  text-align: center;
  transition: all 0.2s ease;
}

.sidebar-subscription-badge.free {
  background: #143028;
  color: #DAFFD1;
  border: 1px solid rgba(218, 255, 209, 0.2);
}

.sidebar-subscription-badge.pro,
.sidebar-subscription-badge.enterprise {
  background: #091a16;
  color: white;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.dark-mode .sidebar-subscription-badge.pro,
.dark-mode .sidebar-subscription-badge.enterprise {
  background: #daffd1;
  color: #143029;
  border: 1px solid rgba(20, 48, 41, 0.1);
}

.sidebar-subscription-badge svg {
  flex-shrink: 0;
}

.sidebar-subscription-badge .badge-text {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 52px;
}

.profile-button {
  width: 40px;
  height: 40px;
  border-radius: 8px;
  background: white;
  border: 1px solid #E5E7EB;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0;
  cursor: pointer;
  overflow: hidden;
  position: relative;
  transition: all 0.2s ease;
}

.dark-mode .profile-button {
  background: #1F2937;
  border-color: #374151;
}

.profile-button:hover {
  border-color: #D1D5DB;
}

.profile-button img {
  width: 40px;
  height: 40px;
  object-fit: cover;
}

.profile-info {
  display: none; /* Hidden by default on compact */
}

.verified-badge {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 14px;
  height: 14px;
  background: #091a16;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
  padding: 0;
}

.dark-mode .verified-badge {
  background: #daffd1;
}

.verified-badge .verified-icon {
  width: 14px;
  height: 14px;
  fill: #091a16;
}

.verified-badge .verified-icon path {
  fill: #091a16;
  stroke: white;
}

.dark-mode .verified-badge .verified-icon path {
  fill: #daffd1;
  stroke: #143029;
}

.verified-badge.blue {
  position: static;
  margin-left: auto;
  background: transparent;
  box-shadow: none;
}

.dark-mode .verified-badge.blue {
  background: transparent;
}

/* Expanded sidebar */
.expanded-sidebar {
  position: absolute;
  left: 64px;
  top: 0;
  width: 240px;
  height: 100vh;
  background: white;
  border-right: 1px solid #E5E7EB;
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  z-index: 20;
  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.05);
}

.expanded-sidebar.dark-mode {
  background: #1F2937;
  border-right-color: #374151;
  box-shadow: 4px 0 10px rgba(0, 0, 0, 0.3);
}

/* Workspace header */
.workspace-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 16px 16px;
  border-bottom: 1px solid #E5E7EB;
}

.dark-mode .workspace-header {
  border-bottom-color: #374151;
}

.workspace-info {
  overflow: hidden;
}

.workspace-name {
  font-size: 15px;
  font-weight: 600;
  color: #111827;
  margin: 0;
}

.workspace-url {
  font-size: 12px;
  color: #6B7280;
}

.dark-mode .workspace-name {
  color: #F9FAFB;
}

.dark-mode .workspace-url {
  color: #9CA3AF;
}

.toggle-button {
  background: transparent;
  border: none;
  color: #6B7280;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  padding: 0;
  cursor: pointer;
}

.dark-mode .toggle-button {
  color: #9CA3AF;
}

/* Switch stores */
.switch-stores {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 16px;
  margin-bottom: 8px;
  color: #6B7280;
  font-size: 14px;
  cursor: pointer;
}

.switch-stores:hover {
  color: #111827;
}

.dark-mode .switch-stores {
  color: #9CA3AF;
}

.dark-mode .switch-stores:hover {
  color: #F9FAFB;
}

/* Main navigation */
.main-navigation {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}

.main-navigation .menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 8px 16px;
  color: #374151;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.main-navigation .menu-item:hover {
  background-color: #E0F2F1;
  color: #128C7E;
}

.main-navigation .menu-item.active {
  background-color: #128C7E;
  color: white;
}

.dark-mode .main-navigation .menu-item {
  color: #D1D5DB;
}

.dark-mode .main-navigation .menu-item:hover {
  background-color: #374151;
}

.dark-mode .main-navigation .menu-item.active {
  background-color: #128C7E;
  color: white;
}

.menu-item svg {
  color: inherit;
  flex-shrink: 0;
}

.dark-mode .menu-item svg {
  color: #9CA3AF;
}

/* Section headers */
.menu-section {
  margin-bottom: 4px;
}

.section-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 12px;
}

.section-header .menu-item {
  flex: 1;
}

.add-button {
  width: 20px;
  height: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: transparent;
  border: none;
  color: #6B7280;
  cursor: pointer;
  border-radius: 4px;
  padding: 0;
}

.add-button:hover {
  background-color: #F3F4F6;
}

.dark-mode .add-button {
  color: #9CA3AF;
}

.dark-mode .add-button:hover {
  background-color: #374151;
}

/* Submenu */
.submenu {
  padding-left: 48px;
}

.submenu-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 6px 16px 6px 0;
  color: #374151;
  text-decoration: none;
  font-size: 14px;
  cursor: pointer;
}

.submenu-item:hover {
  color: #111827;
}

.dark-mode .submenu-item {
  color: #D1D5DB;
}

.dark-mode .submenu-item:hover {
  color: #F9FAFB;
}

.counter {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-width: 20px;
  height: 20px;
  padding: 0 6px;
  background: #F3F4F6;
  color: #6B7280;
  border-radius: 10px;
  font-size: 12px;
  font-weight: 500;
}

.dark-mode .counter {
  background: #374151;
  color: #9CA3AF;
}

/* Navigation item tooltip */
.nav-item, .theme-toggle, .settings-button {
  position: relative;
}

.tooltip-text {
  visibility: hidden;
  position: fixed;
  left: 110%;
  top: 50%;
  transform: translateY(-50%);
  background-color: #1F2937;
  color: white;
  padding: 6px 10px;
  border-radius: 6px;
  font-size: 12px;
  white-space: nowrap;
  pointer-events: none;
  opacity: 0;
  transition: opacity 0.2s ease, visibility 0.2s ease;
  z-index: 40000000000; /* Z-index très élevé pour être au-dessus de tout */
}

.tooltip-text::before {
  content: '';
  position: absolute;
  top: 50%;
  right: 100%;
  transform: translateY(-50%);
  border-width: 6px;
  border-style: solid;
  border-color: transparent #1F2937 transparent transparent;
}

.tooltip-text.visible {
  position: fixed !important;
  z-index: 99999 !important;
  visibility: visible !important;
  opacity: 1 !important;
}

.dark-mode .tooltip-text {
  background-color: #0A1A16;
  color: #F9FAFB;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.dark-mode .tooltip-text::before {
  border-color: transparent #0A1A16 transparent transparent;
}

/* User menu */
.user-menu {
  position: fixed;
  left: 65px;
  bottom: 12px;
  width: 250px;
  background: #FFFFFF !important;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  z-index: 50005;
  display: flex;
  flex-direction: column;
  pointer-events: auto;
}

.dark-mode .user-menu {
  background: #0A1A16 !important;
  border-color: rgba(255, 255, 255, 0.1);
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.5);
}

.user-info {
  padding: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  border-bottom: 1px solid #E5E7EB;
  background: transparent;
}

.dark-mode .user-info {
  border-bottom-color: rgba(255, 255, 255, 0.1);
}

/* Mobile Toggle Button */
.mobile-toggle-container {
    position: fixed;
    top: 16px;
    left: 16px;
    z-index: 50002; /* Extremely high to be above everything */
    pointer-events: auto; /* Ensure clickable */
    display: block; /* Ensure visible */
}

.mobile-toggle-btn {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 40px;
    height: 40px;
    background: white;
    border: 1px solid #E5E7EB;
    border-radius: 8px;
    box-shadow: 0 2px 5px rgba(0,0,0,0.1);
    color: #374151;
    cursor: pointer;
    padding: 0;
}

.dark-mode .mobile-toggle-btn {
    background: #1F2937;
    border-color: #374151;
    color: #D1D5DB;
}


.menu-avatar {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  object-fit: cover;
}

.user-details {
  flex: 1;
  min-width: 0;
}

.user-name {
  display: block;
  font-size: 14px;
  font-weight: 600;
  color: #143028 !important; /* Peelo Green */
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.user-email {
  display: block;
  font-size: 12px;
  color: #6B7280 !important;
  margin-top: 1px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dark-mode .user-name {
  color: #F9FAFB !important;
}

.dark-mode .user-email {
  color: #9CA3AF !important;
  opacity: 0.8;
}

.menu-items {
  padding: 4px 0;
}

/* Subscription Badge */
.subscription-badge {
  display: flex;
  align-items: center;
  gap: 6px;
  padding: 8px 12px;
  margin: 0 8px 8px;
  background: #091a16;
  color: white;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.dark-mode .subscription-badge {
  background: #daffd1;
  color: #143029;
  border: 1px solid rgba(20, 48, 41, 0.1);
}

.subscription-badge svg {
  flex-shrink: 0;
}

.subscription-badge .upgrade-link {
  margin-left: auto;
  padding: 4px 10px;
  background: rgba(255, 255, 255, 0.2);
  color: white;
  text-decoration: none;
  border-radius: 6px;
  font-size: 11px;
  font-weight: 700;
  transition: all 0.2s ease;
}

.dark-mode .subscription-badge .upgrade-link {
  background: rgba(20, 48, 41, 0.1);
  color: #143029;
}

.subscription-badge .upgrade-link:hover {
  background: rgba(255, 255, 255, 0.3);
  transform: translateY(-1px);
}

.dark-mode .subscription-badge .upgrade-link:hover {
  background: rgba(20, 48, 41, 0.2);
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  color: #143028 !important; /* Peelo Green */
  text-decoration: none;
  font-size: 13px;
  font-weight: 500;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.menu-item:hover {
  background-color: #F3F4F6;
}

.dark-mode .menu-item {
  color: #D1D5DB !important;
}

.menu-pro-badge {
  margin-left: auto;
  background: linear-gradient(135deg, #143028, #1f5140);
  color: #DAFFD1;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: .03em;
  padding: 2px 8px;
  border-radius: 20px;
  text-transform: uppercase;
}

.dark-mode .menu-item:hover {
  background-color: #374151;
}

.menu-icon {
  width: 16px;
  height: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6B7280 !important;
}

.dark-mode .menu-icon {
  color: #9CA3AF !important;
}

.shortcut {
  display: none;
}

/* MOBILE RESPONSIVENESS */
@media (max-width: 768px) {
  .sidebar-container {
    width: 100%;
    height: 100%;
    padding: 0;
    pointer-events: none;
  }

  .sidebar {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    width: 280px;
    max-width: 80vw;
    transform: translateX(-100%);
    transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
    box-shadow: 2px 0 8px rgba(0,0,0,0.15);
    z-index: 50001; /* Extremely high */
    border-radius: 0 16px 16px 0;
    padding-top: 16px;
    background: #FFFFFF !important; /* Force white bg */
    pointer-events: auto !important; /* Re-enable clicks */
    display: flex !important; /* Override display:none */
  }

  .sidebar.dark-mode {
    background: #0A1A16 !important; /* Force dark mode bg */
  }

  .sidebar.mobile-open {
    transform: translateX(0);
  }


  
  /* Convert icons to full menu items */
  .nav-item {
    width: 100%;
    justify-content: flex-start;
    padding: 0 24px;
    height: 56px;
    margin-bottom: 4px;
  }
  
  .nav-item svg {
    margin-right: 16px;
    color: #4B5563; /* Darker gray for icons */
    width: 24px;
    height: 24px;
  }
  
  .nav-item.active svg {
    color: #FFFFFF;
  }
  
  /* Show tooltips as text labels */
  .tooltip-text {
    visibility: visible !important;
    position: static !important;
    opacity: 1 !important;
    background: transparent !important;
    color: #1F2937 !important; /* Dark text */
    padding: 0 !important;
    transform: none !important;
    font-size: 16px;
    font-weight: 500;
  }
  
  .dark-mode .tooltip-text {
    color: #F9FAFB !important;
  }
  
  .nav-item.active .tooltip-text {
     color: #FFFFFF !important;
  }
  
  /* Specific styling for external links (Peelo-shop, Console API) - MAKE THEM LOOK LIKE OTHERS */
  .nav-item.nav-external {
      border: none;
      border-radius: 0;
      margin-top: 0;
      background: transparent;
      margin-bottom: 4px; /* Same as others */
  }
  
  .dark-mode .nav-item.nav-external {
      background: transparent;
      border-color: transparent;
  }

  .tooltip-text::before {
    display: none !important;
  }
  
  /* Logo styling */
  .logo-icon {
    margin: 24px 24px 32px 24px;
    width: auto;
    height: auto;
    border: none;
    box-shadow: none;
    justify-content: flex-start;
    padding: 0;
    background: transparent !important;
  }
  
  .logo-icon img {
     width: 120px;
     height: auto;
     object-fit: contain;
  }
  
  /* Profile button styling - MAKE IT LOOK LIKE A MENU ITEM */
  .profile-button {
    width: 100%;
    margin: 0;
    justify-content: flex-start;
    padding: 0 24px;
    height: 56px;
    border-radius: 0;
    background: transparent;
    border: none;
    box-shadow: none;
  }
  
  .dark-mode .profile-button {
      background: transparent;
  }
  
  .profile-button:hover {
      background-color: #F3F4F6;
  }
  
  .dark-mode .profile-button:hover {
      background-color: #374151;
  }
  
  .profile-button img {
    margin-right: 16px;
    width: 24px;
    height: 24px;
    border-radius: 50%;
  }
  
  /* Profile text styles to match menu items */
  .profile-info {
    display: flex;
    flex-direction: column;
    justify-content: center;
  }
  
  .profile-name {
    font-size: 14px;
    font-weight: 500;
    color: #1F2937; /* Match nav text color */
  }
  
  .profile-email {
     display: none; /* Hide email to keep it simple like other items, or keep if preferred? User said "ressembler aux autres", usually simpler. Let's hide email or make it very subtle. Lets hide for now to match height */
  }
  
  /* Verified badge hidden or simplified */
  .profile-button .verified-badge {
    position: static;
    margin-left: 8px;
    width: 16px;
    height: 16px;
  }
  
  .profile-button .verified-badge svg {
    width: 16px;
    height: 16px;
  }

  /* Fix bottom tools to look like menu items */
  .bottom-tools {
      flex-direction: column; /* Stack vertically like menu */
      justify-content: flex-start;
      padding: 0;
      margin-top: 0;
      border-top: none;
      gap: 4px;
      margin-bottom: 16px;
  }
  
  .settings-button, .theme-toggle {
      width: 100%;
      height: 56px;
      padding: 0 24px;
      background: transparent;
      border-radius: 0;
      display: flex;
      gap: 0; /* Icon has margin */
      justify-content: flex-start;
      color: #1F2937;
  }
  
  .settings-button svg, .theme-toggle svg {
      margin-right: 16px;
      color: #4B5563;
      width: 24px;
      height: 24px;
  }

  .dark-mode .settings-button, .dark-mode .theme-toggle {
      background: transparent;
      color: #F9FAFB;
  }
  
  /* Ensure text is visible and styled like nav items */
  .theme-toggle .tooltip-text, .settings-button .tooltip-text {
      display: inline-block !important;
      visibility: visible !important;
      position: static !important;
      opacity: 1 !important;
      font-size: 16px;
      font-weight: 500;
      color: inherit !important;
  }
}

/* Debug Dump Overlay */
.debug-dump-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0,0,0,0.8);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 50000;
  padding: 20px;
}

.debug-dump-content {
  background: #1e1e1e;
  color: #4ade80;
  width: 100%;
  max-width: 600px;
  max-height: 80vh;
  border-radius: 12px;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.debug-header {
  padding: 12px 20px;
  background: #2d2d2d;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: 1px solid #3d3d3d;
}

.debug-header h3 {
  margin: 0;
  font-size: 16px;
  color: #fff;
}

.debug-header button {
  background: none;
  border: none;
  color: #fff;
  font-size: 24px;
  cursor: pointer;
}

.debug-dump-content pre {
  padding: 20px;
  margin: 0;
  overflow: auto;
  font-family: 'SFMono-Regular', Consolas, monospace;
  font-size: 12px;
  line-height: 1.5;
}
</style>

<style>
/* Global styles for Teleported Modal */
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex !important;
  align-items: center;
  justify-content: center;
  z-index: 999999;
  backdrop-filter: blur(2px);
}

.modal-overlay.dark-mode {
  background: rgba(10, 26, 22, 0.85);
}


.premium-modal {
  background: white;
  width: 100%;
  max-width: 480px;
  border-radius: 24px;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.15), 0 0 0 1px rgba(0,0,0,0.05);
  overflow: hidden;
  animation: modalSlideUp 0.3s cubic-bezier(0.16, 1, 0.3, 1);
  display: flex;
  flex-direction: column;
}


@keyframes modalSlideUp {
  from { opacity: 0; transform: translateY(20px) scale(0.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

.premium-modal .modal-header {
  padding: 24px 24px 16px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-bottom: none;
}

.premium-modal .modal-header h3 {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0;
  letter-spacing: -0.02em;
}

.premium-modal .close-btn {
  background: #F3F4F6;
  border: none;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #6B7280;
  cursor: pointer;
  transition: all 0.2s;
}

.premium-modal .close-btn:hover {
  background: #E5E7EB;
  color: #374151;
}

.premium-modal .search-container {
  padding: 0 24px 20px;
}

.premium-modal .search-input-wrapper {
  position: relative;
}

.premium-modal .premium-search-input {
  width: 100%;
  padding: 14px 16px;
  padding-right: 44px;
  background: #F9FAFB;
  border: 1px solid #E5E7EB;
  border-radius: 12px;
  font-size: 15px;
  color: #111827;
  transition: all 0.2s;
  box-sizing: border-box;
}

.premium-modal .premium-search-input:focus {
  background: white;
  border-color: #3B82F6;
  box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.1);
  outline: none;
}

.premium-modal .search-icon {
  position: absolute;
  right: 14px;
  top: 50%;
  transform: translateY(-50%);
  color: #9CA3AF;
  pointer-events: none;
}

.premium-modal .modal-subtitle {
  padding: 0 24px;
  margin-bottom: 12px;
  font-size: 12px;
  font-weight: 600;
  color: #9CA3AF;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.premium-modal .agents-list {
  padding: 0 16px 24px;
  max-height: 360px;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.premium-modal .agent-item {
  display: flex;
  align-items: center;
  padding: 12px;
  border-radius: 12px;
  transition: background 0.2s;
  cursor: pointer;
  border: 1px solid transparent;
}

.premium-modal .agent-item:hover {
  background: #F9FAFB;
  border-color: #F3F4F6;
}

.premium-modal .agent-avatar-wrapper {
  position: relative;
  margin-right: 16px;
}

.premium-modal .agent-avatar {
  width: 44px;
  height: 44px;
  border-radius: 12px;
  background: linear-gradient(135deg, #E0E7FF 0%, #C7D2FE 100%);
  color: #4338CA;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 18px;
  overflow: hidden;
  box-shadow: 0 2px 4px rgba(0,0,0,0.05);
}

.premium-modal .agent-avatar img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.premium-modal .agent-status-dot {
  position: absolute;
  bottom: -2px;
  right: -2px;
  width: 12px;
  height: 12px;
  border-radius: 50%;
  border: 2px solid white;
}

.premium-modal .agent-status-dot.active {
  background-color: #10B981;
  box-shadow: 0 0 0 2px rgba(16, 185, 129, 0.2);
}

.premium-modal .agent-status-dot.inactive {
  background-color: #EF4444;
}

.premium-modal .agent-info {
  flex: 1;
  min-width: 0;
}

.premium-modal .agent-name {
  display: block;
  font-weight: 600;
  font-size: 15px;
  color: #111827;
  margin-bottom: 2px;
}

.premium-modal .agent-email {
  display: block;
  font-size: 13px;
  color: #6B7280;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.premium-modal .select-agent-btn {
  padding: 8px 16px;
  background: white;
  border: 1px solid #E5E7EB;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #374151;
  cursor: pointer;
  transition: all 0.2s;
  box-shadow: 0 1px 2px rgba(0,0,0,0.05);
}

.premium-modal .select-agent-btn:hover {
  background: #111827;
  color: white;
  border-color: #111827;
}

.premium-modal .empty-search {
  text-align: center;
  padding: 40px 0;
  color: #9CA3AF;
  font-size: 14px;
}

/* === Dark Mode Overrides for Teleported Modal === */
.modal-overlay.dark-mode .premium-modal {
  background: #0A1A16;
  border: 1px solid rgba(255, 255, 255, 0.1);
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.5);
}

.modal-overlay.dark-mode .premium-modal .modal-header h3 {
  color: #FFFFFF;
}

.modal-overlay.dark-mode .premium-modal .close-btn {
  background: rgba(255, 255, 255, 0.08);
  color: #6B7280;
}

.modal-overlay.dark-mode .premium-modal .close-btn:hover {
  background: rgba(255, 255, 255, 0.15);
  color: #FFFFFF;
}

.modal-overlay.dark-mode .premium-modal .premium-search-input {
  background: rgba(255, 255, 255, 0.05);
  border-color: rgba(218, 255, 209, 0.15);
  color: #FFFFFF;
}

.modal-overlay.dark-mode .premium-modal .premium-search-input::placeholder {
  color: rgba(255, 255, 255, 0.4);
}

.modal-overlay.dark-mode .premium-modal .premium-search-input:focus {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(218, 255, 209, 0.3);
  box-shadow: 0 0 0 4px rgba(218, 255, 209, 0.1);
}

.modal-overlay.dark-mode .premium-modal .search-icon {
  color: #daffd1;
}

.modal-overlay.dark-mode .premium-modal .modal-subtitle {
  color: #9CA3AF;
}

.modal-overlay.dark-mode .premium-modal .agent-item:hover {
  background: rgba(218, 255, 209, 0.08);
  border-color: rgba(218, 255, 209, 0.1);
}

.modal-overlay.dark-mode .premium-modal .agent-avatar {
  background: linear-gradient(135deg, rgba(218, 255, 209, 0.15) 0%, rgba(218, 255, 209, 0.08) 100%);
  color: #daffd1;
}

.modal-overlay.dark-mode .premium-modal .agent-status-dot {
  border-color: #0A1A16;
}

.modal-overlay.dark-mode .premium-modal .agent-name {
  color: #FFFFFF;
}

.modal-overlay.dark-mode .premium-modal .agent-email {
  color: rgba(218, 255, 209, 0.7);
}

.modal-overlay.dark-mode .premium-modal .select-agent-btn {
  background: rgba(255, 255, 255, 0.08);
  border-color: rgba(255, 255, 255, 0.15);
  color: #FFFFFF;
  box-shadow: none;
}

.modal-overlay.dark-mode .premium-modal .select-agent-btn:hover {
  background: #daffd1;
  color: #0A1A16;
  border-color: #daffd1;
}
</style>
 